import React from 'react';

const VendorDashboard = () => {
  return (
    <div>
      <h1>Admin Dashboard</h1>
      <p>Welcome to the Admin dashboard!</p>
    </div>
  );
};

export default VendorDashboard;